import React, { useEffect, useState } from "react";
import { useOutletsQuery } from "../../../Store/Apis/outletApi";
import { useCustomerOrderReportQuery } from "../../../Store/Apis/reportApi";
import { fetchAllReports } from "../../../Store/Apis/ReservationApi";
import getStatusColor from "../../../Hooks/GetStatusColor";
import downloadPDF from "../../../Hooks/downloadReportPdf";
import { Link } from "react-router-dom";
import { isDropdownPermission } from "../../../Hooks/permissionsMiddleware";
import { useSelector } from "react-redux";
// Helper function to get formatted date (YYYY-MM-DD)
const getFormattedDate = (date) => {
  return date.toISOString().split("T")[0];
};
const AllReports = () => {
  const user = useSelector((state) => state.auth.user);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const [startDate, setStartDate] = useState(getFormattedDate(yesterday));
  const [endDate, setEndDate] = useState(getFormattedDate(today));

  const handleDownload = async () => {
    try {
      const response = await fetchAllReports({
        startDate,
        endDate,
      });

      console.log("Response:", response);

      if (response && response.success) {
        console.log("File downloaded successfully");
        // You could show a success toast here if needed
      } else {
        console.error("Failed to download reports:", response?.message);
        // You could show an error toast here if needed
      }
    } catch (error) {
      console.error("Error during file download:", error);
    }
  };

  return (
    <div>
      <div className="row align-items-center justify-content-between mb-2">
        <div className="col">
          <h5 className="fw-500 text-white">Download All Reports</h5>
        </div>
      </div>
      <div className="card mb-4">
        <div className="card-header rounded-3 p-4">
          <div className="row">
            <div className="col-md-5 col-sm-5">
              <label>Start Date</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-5 col-sm-5">
              <label>End Date</label>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="col-md-2 col-sm-2">
              <div className="d-flex justify-content-end align-items-center h-100 pt-4">
                <button
                  className="btn btn-success w-100 mb-0"
                  onClick={handleDownload}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllReports;
